import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationRadiusModalComponent } from './location-radius-modal/location-radius-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from '../../../tools/mat-col/mat-col.component';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';

@NgModule({
  declarations: [LocationRadiusModalComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, ToolsModule, MatColComponent, MatRowComponent],
  exports: [LocationRadiusModalComponent],
})
export class LocationRadiusModalModule {}
